"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { toast } from "sonner";
import { useUser } from "#/hooks/use-user";
import EditProfileCard from "./EditProfileCard";
import { jsx as _jsx } from "react/jsx-runtime";
export function EditProfileView(t0) {
  const $ = _c(12);
  const {
    authClient,
    user,
    onSuccess,
    onBack,
    statusMessage: initialStatusMessage,
    onStatusMessageAction
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    updateProfile,
    isUpdating
  } = useUser(t1);
  const [statusMessage, setStatusMessage] = useState(initialStatusMessage);
  let t2;
  if ($[2] !== onSuccess || $[3] !== updateProfile) {
    t2 = async (firstName, lastName) => {
      const response = await updateProfile(firstName, lastName);
      if (response.success) {
        toast.success(response.message);
        setStatusMessage({
          message: response.message,
          variant: "confirmation"
        });
        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.error(response.message);
        setStatusMessage({
          message: response.message,
          variant: "error"
        });
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = updateProfile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleProfileUpdate = t2;
  let t3;
  if ($[5] !== handleProfileUpdate || $[6] !== isUpdating || $[7] !== onBack || $[8] !== onStatusMessageAction || $[9] !== statusMessage || $[10] !== user) {
    t3 = /*#__PURE__*/_jsx(EditProfileCard, {
      user: user,
      handleProfileUpdate: handleProfileUpdate,
      onBack: onBack,
      statusMessage: statusMessage,
      onStatusMessageAction: onStatusMessageAction,
      isLoading: isUpdating
    });
    $[5] = handleProfileUpdate;
    $[6] = isUpdating;
    $[7] = onBack;
    $[8] = onStatusMessageAction;
    $[9] = statusMessage;
    $[10] = user;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}